<section>
  <div class="flex-container">
    <div class="flex-row">
      <div class="flex-col-12">
        <h1 class="ui-headline">{{ 'settings.title' | translate }}</h1>
      </div>
    </div>
  </div>
  <ng-container *ngIf="customer">
    <app-profile-desktop
      *ngIf="!mobileView"
      [customer]="customer"
      [activeTabName]="openTab"
      [kind]="currentAccountDetail.kind"
      [stepStatus]="currentAccountDetail.step_status"
      [hasI4KAccount]="hasI4KAccount"
      [hasCIAccount]="customer?.has_crowd_investor_account"
      (changeTab)="changeTab($event)"
      (showPromotions)="showPromotions()"
    ></app-profile-desktop>
    <app-profile-mobile
      *ngIf="mobileView"
      [customer]="customer"
      [activeTabName]="openTab"
      [kind]="currentAccountDetail.kind"
      [stepStatus]="currentAccountDetail.step_status"
      [hasI4KAccount]="hasI4KAccount"
      [hasCIAccount]="customer?.has_crowd_investor_account"
      (changeTab)="changeTab($event)"
      (showPromotions)="showPromotions()"
    ></app-profile-mobile>
  </ng-container>
</section>
